const commonMessages = {
  'common.ui.button.submit': 'Submit',
  'common.ui.button.sign-in': 'Sign in',
  'common.ui.button.sign-out': 'Sign out',
  'common.ui.button.continue': 'Continue',
  'common.ui.button.cancel': 'Cancel',
  'common.ui.button.save': 'Save',
  'common.ui.button.done': 'Done',
  'common.ui.button.save-for-later': 'Save for later',
  'common.ui.button.update': 'Update',
  'common.ui.button.export': 'Export',
  'common.ui.button.log-out': 'Log out',
  'common.ui.button.prev': 'Previous',
  'common.ui.button.next': 'Next',
  'common.ui.button.retry': 'Retry',
  'common.logo.alt': 'ODIN logo',
  'common.copyright': 'Copyright © 2025 Beonhand',
  'common.odin.description': 'OnHand Data and Insight Network',
  'common.home.breadcrumb': 'Home',
  'common.features.not-implemented':
    'This feature is not currently available - come back soon when it is implemented.',
}

export default commonMessages
